import { __assign } from "tslib";
import * as React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles } from '../../styles';
import { useComboboxContext } from '../Combobox.context';
export var useStyles = makeStyles(function () {
    return createStyles({
        root: {
            display: 'flex',
            padding: '8px 12px',
        },
        isMulti: {
            flexWrap: 'wrap',
            padding: '2px 4px',
        },
    });
});
export var InputWrap = function (props) {
    var _a;
    var _b = useComboboxContext(), components = _b.components, value = _b.value, comboboxProps = _b.comboboxProps;
    var SingleValue = components.SingleValue, MultiValue = components.MultiValue, Combobox = components.Combobox, ValueWrap = components.ValueWrap;
    var isMulti = comboboxProps.isMulti, id = comboboxProps.id, ValueWrapProps = comboboxProps.ValueWrapProps, disabled = comboboxProps.disabled;
    var classes = useStyles(props);
    return (React.createElement(React.Fragment, null,
        value.length > 0 && (React.createElement(ValueWrap
        // Note: using a span here to avoid cascading `> div` styles from InputBaseOverrides.
        , __assign({ 
            // Note: using a span here to avoid cascading `> div` styles from InputBaseOverrides.
            component: "span", 
            // Id required for input aria-describedby.
            id: "combobox-value-".concat(id) }, ValueWrapProps, { 
            // Declare after spread to merge consumer styles with internal styles.
            className: clsx(classes.root, (_a = {}, _a[classes.isMulti] = isMulti, _a), ValueWrapProps === null || ValueWrapProps === void 0 ? void 0 : ValueWrapProps.className) }),
            isMulti &&
                value.map(function (option) { return (React.createElement(MultiValue, { option: option, key: option.value, disabled: disabled })); }),
            !isMulti && React.createElement(SingleValue, { option: value[0] }))),
        React.createElement(Combobox, __assign({}, props))));
};
export default InputWrap;
//# sourceMappingURL=Combobox.InputWrap.js.map